<div style="display: flex; flex-direction: column;">
@for(category of (questionnaire()?.categories?.values() ?? []);track $index){
    <div class="category-wrapper">
        <div class="questions-wrapper">
            @for(question of category.questions; track question){
            <div class="question-wrapper">
                <cwo-question [question]="question" [response]="responseFromQuestion(question.id)"
                    (responseChanged)="responseChanged(question.id, $event)" />
            </div>
            }
        </div>
    </div>
    @if($index !== (questionnaire()?.categories?.length ?? 0) - 1){
    <div class="divider"></div>
    }
    }
</div>